import React from 'react';
import { UserCheck } from 'lucide-react';
import SwipeToast from './SwipeToast';

/**
 * Notificacao de transferencia para atendimento humano.
 *
 * Suporta dois modos:
 * - Individual (batch de 1): mostra nome do contato + motivo, CTA "Abrir conversa"
 * - Agregado (batch > 1): mostra contagem, CTA "Ver primeiro" abre o mais antigo
 *
 * O agrupamento eh feito pelo hook useContactTransferredNotifications em
 * janela de 8s, evitando que 30 transferencias simultaneas gerem 30 toasts
 * sequenciais.
 */
const ContactTransferredNotification = ({
  isOpen,
  batch,
  onOpenChat,
  onDismiss,
}) => {
  const list = Array.isArray(batch) ? batch : [];
  const count = list.length;
  if (count === 0) return null;

  const first = list[0] || {};
  const displayName = first.contact_name || first.contact_phone || 'Contato';

  let title;
  let description;
  let ctaLabel;
  if (count === 1) {
    title = 'Atendimento transferido para humano';
    description = first.reason
      ? `${displayName} precisa da sua atencao. Motivo: ${first.reason}`
      : `${displayName} foi transferido pelo agente e precisa da sua atencao.`;
    ctaLabel = 'Abrir conversa';
  } else {
    title = `${count} atendimentos transferidos`;
    description = `${count} contatos foram transferidos para atendimento humano, incluindo ${displayName}.`;
    ctaLabel = 'Abrir primeiro';
  }

  const handleCta = () => {
    if (typeof onOpenChat === 'function') {
      onOpenChat(first);
    }
  };

  return (
    <SwipeToast
      isOpen={isOpen}
      icon={<UserCheck size={20} />}
      title={title}
      description={description}
      ctaLabel={ctaLabel}
      onCta={handleCta}
      onDismiss={onDismiss}
      accentColor="#2563EB"
    />
  );
};

export default ContactTransferredNotification;
